import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkIcon from 'react/shared/components/true_link/main/TrueLinkIcon';
import PALETTE from 'react/shared/theme/palette';

const useStyles = makeStyles({
  listIcon: {
    color: PALETTE.emerald,
    paddingRight: '10px',
  },
  unorderedList: {
    listStyle: 'none',
    marginLeft: '0',
    paddingLeft: '0',
  },
  unorderedListItem: {
    lineHeight: '1.75rem',
    paddingLeft: '1em',
    textIndent: '-1em',
    '&:not(:last-child)': {
      marginBottom: '10px',
    },
  },
});

export default function SignUpTextList({ className, listItems }) {
  const classes = useStyles();

  return (
    <ul className={classNames(classes.unorderedList, className)}>
      {listItems.map((item, index) => (
        <li className={classes.unorderedListItem} key={index}>
          <TrueLinkIcon className={classes.listIcon} icon="check" />
          {item}
        </li>
      ))}
    </ul>
  );
}

SignUpTextList.propTypes = {
  className: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.node).isRequired,
};
